
import { TipoQuestionario } from '../models/tipo-questionario';
import { CategoriaPergunta } from '../models/categoria-pergunta';

export class Questionario {
  // Raw attributes
  public id: number;
  public denominacao: string;
  public nomeUnico: string;
  public dataInicio: Date;
  public dataFim: Date;
  public tipoQuestionario: number;
  public codigoPergunta: number;
  public metodoValidador: string;
  public metodoInicializador: string;
  public mostrarCategoria: boolean;
  public mostrarUsuarioCriador: boolean;
  public mostrarDataCriacao: boolean;
  public mostrarPontuacao: boolean;
  public mostrarSalvarConcluir: boolean;
  public mostrarRespostaModal: boolean;


  // transient
  public categorias:CategoriaPergunta[];
}
